// extracted by mini-css-extract-plugin
export default {"intput_div":"taglist_intput_div__Rpfqu","addlistbtn":"taglist_addlistbtn__WzwBj","cancelbtn":"taglist_cancelbtn__fZG1O"};